import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import ClientApplicationForm, {
  ClientApplicationFormRef,
  ClientApplicationValues,
} from './ClientApplicationForm';
import { IClientApplication } from '@nxsys/types/models/clientApplication';
import AppDescription from '@nxsys/components/AppDescription';
import { Descriptions } from 'antd';

type EditClientApplicationModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: ClientApplicationValues) => Promise<void>;
  data: IClientApplication;
};

const EditClientApplicationModal: React.FC<EditClientApplicationModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<ClientApplicationFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: ClientApplicationValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['company.clientApplication.editTitle']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <div className="p-[12px] bg-neutral-50 rounded-[8px] mb-[16px] border border-neutral-100">
        <AppDescription
          column={1}
          labelStyle={{ width: 216 }}
          bordered={false}
          colon={false}
          size="middle"
        >
          <Descriptions.Item
            label={messages['company.clientApplication.clientName']}
          >
            {data?.clientName || '-'}
          </Descriptions.Item>
          <Descriptions.Item
            label={messages['company.clientApplication.redirectUrl']}
          >
            {data?.redirectUris.join(', ') || '-'}
          </Descriptions.Item>
        </AppDescription>
      </div>
      <ClientApplicationForm
        formRef={formRef}
        onSubmit={handleSubmit}
        data={data}
      />
    </AppModalContainer>
  );
};

export default EditClientApplicationModal;
